/** @format */

import { KillSwitches } from '@shared/data-access/interfaces';

const killSwitchProd: KillSwitches = {
	// please keep in alpha order
	availabilityOnProductCardsEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	boplExperienceEnabled: {
		dsg: true,
		gg: false,
		pl: true,
		g3: false
	},
	browseBreadcrumbsEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	certonaQuickviewEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	crossChainBopis: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	enableTooltipSurvey: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	favoritesEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	isBotCheckEnabled: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	isServerSideRenderStateDataEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	isPLPMLIntegrationEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	isPLPServerSideRenderEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	isPLPRedisEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	isSRLPRedisEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	listsEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	newEATApiEnabled: {
		dsg: true,
		gg: false,
		pl: true,
		g3: false
	},
	isPartyAttributesEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	sameDayDeliveryEnabled: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	shopAllCategoryBubbleEnabled: {
		dsg: true,
		gg: false,
		pl: false,
		g3: false
	},
	showPinnedProducts: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	showPinnedContent: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	skuFavoritesEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	useNewPricingService: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	useQVProductTemplate: {
		dsg: false,
		gg: false,
		pl: true,
		g3: true
	},
	isPLPProTipsEnabled: {
		dsg: true,
		gg: true,
		pl: true,
		g3: false
	},
	plpGoogleAdManagerEnabled: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	showNewSponsoredLabel: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	showPLPSponsoredProducts: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	plpSearchResultSurveyEnabled: {
		dsg: true,
		gg: true,
		pl: false,
		g3: true
	},
	plpFilterResultSurveyEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	plpShowCustomerRating: {
		dsg: true,
		gg: true,
		pl: true,
		g3: true
	},
	triggerSponsoredProductsIntendedEvent: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	triggerSponsoredProductsShownEvent: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	usePerformancePageSize: {
		dsg: false,
		gg: false,
		pl: false,
		g3: true
	},
	compareCheckboxEnabled: {
		dsg: false,
		gg: true,
		pl: true,
		g3: false
	},
	compareGridEnabled: {
		dsg: false,
		gg: true,
		pl: true,
		g3: false
	},
	//for enabling images swatches
	useImageSwatches: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isUsingCriteoSPAAdServer: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	isSPAPosition2Enabled: {
		dsg: true,
		gg: true,
		pl: false,
		g3: false
	},
	isSPAShelfEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isDigitalShelfTalkerEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	isNarrowGAMBannerEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	fulfillmentFacetsEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	sortByCustomerRatingEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	},
	exposedFiltersEnabled: {
		dsg: false,
		gg: false,
		pl: false,
		g3: false
	}
};

export default killSwitchProd;
